/*
 * AppBackButton Messages
 *
 * This contains all the text for the AppBackButton component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.AppBackButton';

export default defineMessages({
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Back to the workspace',
  },
});
